#import "./calendar-fragment.graphql"

fragment CalendarSync on CalendarSync {
    username
    externalService
    isEnabled
    importIsEnabled
    syncErrors
    calendars {
        ...CalendarFragment
    }
}
